<template>
  <b-card
    no-body
    v-draggable
    ref="generic_subcard"
    id="generic-subcard"
  >
    <!-- Header -->
    <b-card-header
      style="color: green; height: 25px; cursor: move"
      class="pl-2 pb-0 pt-0"
      header-tag="div"
      header-bg-variant="dark"
    >
      <b-row class="mx-0 px-0">
        <b-col class="mx-0 px-0" cols="11">
          {{ headLine }}
        </b-col>
        <b-col class="mx-0 px-0" cols="1" style="text-align: right">
          <font-awesome-icon
            class="mx-1 clickable"
            :icon="['far', 'times']"
            @click="close()"
          />
        </b-col>
      </b-row>
    </b-card-header>

    <!-- Content -->
    <b-card-text class="pl-3 pr-3" style="overflow: auto">
      <b-row class="m-0 mt-2 mb-4" style="width: 100%" v-html="innerHtml">
        Upps - 404
      </b-row>
    </b-card-text>
  </b-card>
</template>

<script>
export default {
  name: "GenericPopup",
  props: {
    headLine: String,
    innerHtml: String
  },
  created: function() {
    window.addEventListener('keyup', this.handleKeyUp);
  },
  methods: {
    close() {
      window.removeEventListener('keyup', this.handleKeyUp);
      this.$emit('close');
    },
    handleKeyUp(event) {
      if (event.key == 'Escape') {
        this.close();
      }
    },
  }
};
</script>
